export default {
  name: 'evaluationstatistics',
  path: 'evaluationstatistics',
  component: () =>
    import(/* webpackChunkName: "evaluationstatistics" */ './index.vue')
}
